var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "paragraph",
  "use": "paragraph-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"paragraph\"><rect fill=\"none\" height=\"50\" width=\"50\" /><path d=\"M34.397,29L20,48L5.604,29  H15C15,0,44,1,44,1S25,2.373,25,29H34.397z\" fill=\"none\" stroke=\"#000000\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id